<template>
  <div class="artstyle">
    <div id="articlecont">
      <h1 class="articletitle">{{articlecont.title}}</h1>
      <div class="setarticle">
        <div>
          <span>发布时间：{{articlecont.createtime}}</span>
          <span>来源：中国老年大学协会</span>
        </div>
      </div>
    </div>
    <ul>
      <li v-for="item in formList" :key="item.id" @click="downword(item.id)">
        <div class="img-box" :class="{docIcon:item.suffix == 1}" v-if="item.suffix == 1"></div>
        <div class="img-box" :class="{pdfIcon:item.suffix == 2}" v-if="item.suffix == 2"></div>
        <div class="img-box" :class="{xlsIcon:item.suffix == 3}" v-if="item.suffix == 3"></div>
        <span>{{item.name}}</span>
        <div class="download-box">
          <div></div>
          <span>下载</span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Api from "@/api/commonApi";
import saveAs from "file-saver";
import store from "../store";
import Axios from "axios";
export default {
  data() {
    return {
      // radio4: "大",
      // articlesize: 20,
      // downloadimgUrl: require("@/assets/icon_download7a.png"),
      // printimgUrl: require("@/assets/icon_print7a.png"),
      articlecont: {},
      formList: []
    };
  },
  props: ["menu", "articletitle"],
  computed: {},
  created() {
    this.showarticle(this.articletitle);
  },
  methods: {
    showarticle(articletitle) {
      // 根据传过来的 articletitle 获取文章
      Api.getUploadFileList(articletitle)
        .then(res => {
          const { formInfo, list } = res.data;
          this.articlecont = formInfo;
          this.formList = list;
        })
        .catch(err => console.log(err));
    },
    downword: function(id) {
      window.location.href = `${process.env.baseURI}/index/downFile?file_id=${id}`;
    }
  },
  watch: {
    $route(to, from) {
      !from.params.articletitle &&
      !to.params.currentPage &&
      to.params.articletitle !== from.params.articletitle
        ? this.showarticle(to.params.articletitle)
        : "";
    }
  }
};
</script>
<style lang="scss" scoped>
%mgto {
  margin: 0 auto;
}
%ulst {
  margin: 0;
  padding: 0;
  list-style: none;
}

@mixin displayflex($row, $column, $direction, $wrap) {
  display: flex;
  @if $direction == column {
    flex-direction: column;
  } @else {
    flex-direction: row;
  }
  @if $wrap == wrap {
    flex-wrap: wrap;
  } @else {
    flex-wrap: nowrap;
  }
  justify-content: $row;
  align-items: $column;
}
.box-border {
  box-sizing: border-box;
}
@mixin font-style($family, $size, $color, $weight) {
  font-family: $family;
  font-size: $size;
  color: $color;
  font-weight: $weight;
}

$pd-lf: padding-left;

.artstyle {
  @extend %mgto;
  width: 1200px;
  background: #ffffff;
  margin-bottom: 40px;
  position: relative;
  @extend .box-border;
  padding: 80px;
  &:nth-child(1) {
    width: 100%;
    @include displayflex(flex-start, center, column, nowrap);
  }
  & > ul {
    padding-left: 0;
    & > li {
      @include displayflex(flex-start, center, row, nowrap);
      line-height: 28px;
      padding-top: 14px;
      padding-bottom: 14px;
      border-bottom: 1px dashed #dbdbdb;
    }
    .img-box {
      width: 20px;
      height: 25px;
      margin-right: 14px;
      background-size: 100% 100%;
    }
    .img-box.docIcon {
      background-image: url("../assets/online_service/word.png");
    }
    .img-box.pdfIcon {
      background-image: url("../assets/online_service/pdf.png");
    }
    .img-box.xlsIcon {
      background-image: url("../assets/online_service/xls.png");
    }

    span {
      flex: 1;
      @include font-style("PingFangSC-Regular", 16px, rgba(58, 58, 58, 1), 400);
      // line-height: 22px;
      line-height: 28px;
    }
    :hover {
      color: #c52e0f;
      cursor: pointer !important;
    }
    .download-box {
      width: 64px;
      @include displayflex(space-between, center, row, nowrap);
      div {
        width: 24px;
        height: 22px;
        background-image: url("../assets/online_service/download-icon.png");
        background-size: 100% 100%;
      }
      span {
        flex: 1;
        text-align: right;
        @include font-style(
          "PingFangSC-Regular",
          14px,
          rgba(122, 122, 122, 1),
          400
        );
        line-height: 28px;
      }
    }
    :hover {
      cursor: pointer !important;
      span {
        color: #c52e0f;
      }
    }
  }
}

.articletitle {
  @include font-style("PingFangSC-Medium", 30px, #3a3a3a, 500);
  width: 1040px;
  text-align: center;
}

.setarticle {
  width: 100%;
  @include displayflex(space-between, center, row, nowrap);
  @include font-style("PingFangSC-Regular", 14px, #7a7a7a, 400);
  border-bottom: 1px dashed #dbdbdb;
  margin-bottom: 50px;
  & > div {
    margin: 40px 30px;
    &:nth-child(1) {
      & > span:nth-child(1) {
        margin-right: 40px;
      }
    }
  }
}

.contentsize {
  @include font-style("PingFangSC-Regular", 20px, #3a3a3a, 400);
}
</style>
<style lang="scss">
@mixin font-style($family, $size, $color, $weight) {
  font-family: $family;
  font-size: $size;
  color: $color;
  font-weight: $weight;
}
.el-radio-group {
  & > label {
    & > span {
      padding: 7px 7px !important;
      border-radius: 2px !important;
      margin-left: 6px;
      background: #f4f4f4;
      border: 0 !important;
      box-shadow: none !important;
      @include font-style("PingFangSC-Regular", 18px!important, #3a3a3a, 400);
      &:hover {
        color: #3a3a3a;
      }
    }
    & > input:checked + span {
      background: #c52e0f !important;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/form.vue